export default __webpack_public_path__ + "static/media/king_of_wands.d8c68383.png";